const configEndpoints = {
  getClientConfigUrl: (baseUrl) => `${baseUrl}/api/v1/ClientConfig`,
};

export default configEndpoints;
